<section class="sso-waiting text-center" aria-live="polite">
  @switch (state()) {
    @case ('slow') {
      <p class="sso-waiting__message">This is taking a little longer than usual.</p>
      @if (canRetry()) {
        <button type="button" class="btn default-cgp-btn sso-waiting__action" (click)="retry()">Try again</button>
      } @else if (kenticoRetryUrl(); as retryUrl) {
        <!-- The token has expired: Kentico issues a fresh one -->
        <a class="btn default-cgp-btn sso-waiting__action" [href]="retryUrl">Try again</a>
      } @else {
        <a class="btn default-cgp-btn sso-waiting__action" routerLink="/login">Log in</a>
      }
    }
    @case ('failed') {
      <p class="sso-waiting__message">Sorry, we couldn’t sign you in automatically.</p>
      @if (kenticoRetryUrl(); as retryUrl) {
        <!-- Kentico issues a fresh token from the user's Kentico session -->
        <a class="btn default-cgp-btn sso-waiting__action" [href]="retryUrl">Try again</a>
      }
      <a class="btn default-cgp-btn sso-waiting__action" routerLink="/login">Log in</a>
    }
    @default {
      <!-- Every in-progress state (exchanging, provisioning) shows the welcome message straight away:
           the loader is never shown on its own (product decision, TFS.69299 review). -->
      <div class="sso-waiting__loader" aria-hidden="true">
        <div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>
      </div>
      <p class="sso-waiting__message">Welcome! We’re just getting your RevisionHub set up, it’ll only take a moment 😊</p>
    }
  }
</section>
